import React from 'react';
var Title = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (React.createElement("div", { className: 'title-container' },
        React.createElement("h1", { className: 'title' }, title),
        subtitle && React.createElement("p", { className: 'title__sub-title' }, subtitle)));
};
export default Title;
